import InputField from "../../ui/InputField/InputField";
import classes from "../BasicInfo/BasicInfo.module.css"

const availabilityOptions = [
    "Rented",
    "Maintenance",
    "Available"
] 

const Pricing = ({ formData, updateFormData }) => {
    const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  return (
    <div className={classes.form}>
      <h4>Pricing</h4>
      
      <div className={classes.group}>
        <InputField labelText="Local hire daily rate" placeholder="Eg. 200" name="localDailyRate" type="number" value={formData.localDailyRate} required onChange={handleChange}/>
      </div>
      <div className={classes.group}>
        <InputField labelText="Outside city hire daily rate (optional)" placeholder="Leave blank if not offered" name="outsideCityDailyRate" type="number" value={formData.outsideCityDailyRate} onChange={handleChange}/>
      </div>
       <div className={classes.group}>
        <InputField labelText="Availability status" name="availability" value={formData.availability} options={availabilityOptions} required onChange={handleChange}/>
      </div>
    </div>
  );
}

export default Pricing